import React from 'react';
import { Box } from '@tanium/react-box';
import { useTranslation } from './localization';
import { RequiredStar } from './RequiredStar';
import { RequiredText } from './themeDefinitions';

export const RequiredKey = () => {
  const { t } = useTranslation();
  return (
    <Box color={RequiredText} fontSize={12} lineHeight="16px">
      <RequiredStar /> {t('Required')}
    </Box>
  );
};
